import mori from 'mori';

export function getCurrentDistributions(distributions, options) {
  // Currently selected distributions by matching slugs, or all
  return (
    (mori.count(distributions) === 0 &&
     (options.activeTab !== 'graph' ||
      mori.count(distributions) === 1)) ?
    distributions :
    mori.filter((x) => {
      return options.selectedDistributions ?
        [].concat(options.selectedDistributions.split('--'))
          .indexOf(mori.get(x, 'slug')) > -1 : false;
    }, distributions)
  );
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/util/dataFilters.js